import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InvoiceComponent } from './invoice/invoice.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { Account } from 'src/app/models/account.model';
import { BadgeData } from '../../../models/badge.model';
import { BADGECOUNTS } from 'src/app/shared/constants';
import { CacheService } from 'src/app/services/cache.service';
import { ShortCodesRole } from 'src/app/models/constants';
import { Subscription } from 'rxjs';
import { ScrBaseComponent } from '../../base.component';
import { AccountService } from 'src/app/services/account.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent extends ScrBaseComponent implements OnInit, OnDestroy {

  public displayedOrders: number[] = [];
  public displayedInvoices: number[] = [];
  invoiceCount = 0;
  needsPaymentCount = 0;

  private cacheSubscription?: Subscription;
  cachedAccount: Account = {} as Account;

  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;

  constructor(
    private router: Router, 
    private cacheService: CacheService, 
    private accountService: AccountService,
    private logger: NGXLogger) { super(); }

 
  ngOnInit(): void {
    this.observe(this.accountService.getAccount(), rsp => {
      this.cachedAccount = rsp.account;
      return false;
    });
    this.cacheSubscription = this.cacheService.subscribe<BadgeData>(BADGECOUNTS).subscribe(badgecounts => {
      // this.log.debug('billing order cache subscribe gave me ' + JSON.stringify(badgecounts));
      if (badgecounts) {
        this.needsPaymentCount = badgecounts.needsPaymentCount;
        this.invoiceCount = badgecounts.monthlyInvoiceCount;
      }
    });


  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.cacheSubscription) {
      this.cacheSubscription.unsubscribe();
    }
  }

  public componentAdded(child: InvoiceComponent|OrderDetailComponent): void {
    this.logger.debug('child added ' + child);

    if (child instanceof InvoiceComponent) {
      if (!this.displayedInvoices.includes(+child.orderId)) {
        this.displayedInvoices.push(+child.orderId);
      }
    }
    else if (child instanceof OrderDetailComponent) {
      if (!this.displayedOrders.includes(child.orderId)) {
        this.displayedOrders.push(child.orderId);
      }
    }
  }

  /**
   * Invoice is being closed, return to view orders.
   * @param event - event being processed.
   * @param id - close the invoice tab with this id.
   */
  closeInvoice(event: Event, id: number): void {
    this.displayedInvoices = this.displayedInvoices.filter(o => o !== id);
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['billing', { outlets: { 'billing-tab': ['view-orders'] } }] } }]);
    event.preventDefault();
  }

  /**
   * Order is being closed, return to view orders.
   * @param event - event being processed.
   * @param id - close the invoice tab with this id.
   */
  closeOrder(event: Event, id: number): void {
    this.displayedOrders = this.displayedOrders.filter(o => o !== id);
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['billing', { outlets: { 'billing-tab': ['view-orders'] } }] } }]);
    event.preventDefault();
  }
}
